<h1 mat-dialog-title>اطلاعات زیر را با دقت تکمیل نمایید</h1>
<div mat-dialog-content>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'letterTypeID'"
    [fieldLabel]="'نوع معرفی نامه'"
    [options]="letterTypeList"
  ></app-select-field>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'stateID'"
    [fieldLabel]="'استان'"
    (OnChange)="onStateChange($event)"
    [options]="stateList"
  ></app-select-field>
  <app-select-field
    [Group]="formGroup"
    [fieldName]="'cityID'"
    [fieldLabel]="'شهر'"
    [options]="cityList"
  ></app-select-field>
  <app-input-field
    [Group]="formGroup"
    [fieldLabel]="'نام مرکز'"
    [fieldName]="'centerName'"
    [dataType]="['varchar']"
  ></app-input-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">بازگشت</button>
  <button mat-button [disabled]="!formGroup.valid" (click)="getNewSubset()" cdkFocusInitial>تایید
  </button>
</div>
